import { render } from "./AllUsers.vue?vue&type=template&id=67ffbc48&ts=true"
import script from "./AllUsers.vue?vue&type=script&lang=ts"
export * from "./AllUsers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__